import { withStyles } from "@material-ui/core/styles";
import styles from "./FranchiseTableStyles";
import { Grid, Paper ,IconButton, Button, TextField, FormControlLabel, Checkbox } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from "react";

const FranchiseTable = ({ classes, franchiseList, setHandleModal, setRecord, handleSearch, handleReset, checkApp, handleCheckApp, checkStatus, handleCheckStatus}) => {

  const [search, setSearch] = useState("")

  const feeFormatter = (value) => {
    const numvalue = Number(value);
    const feeamount = isNaN(numvalue) ? 0 : numvalue;
    return `₹${feeamount.toLocaleString('en-IN')}`
  }

  const columns = [
    { field: 'name', 
      headerName: 'Name', 
      flex: 1.5,
      renderHeader: () => {
        return (
          <div style={{ marginLeft: '20px' }}>
            Name
          </div>
        );
      },
      renderCell: (params) => {
        return (
          <div style={{ marginLeft: '20px' }}>
            {params.value}
          </div>
        );
      }
    },
    { field: 'franchisee_code',
      headerName: 'Franchise Code', 
      align: 'center',
      headerAlign: 'center',
      flex: 1
    },
    {
      field: 'feeamount',
      headerName: 'Fee Amount',
      type: 'number',
      align: 'center',
      headerAlign: 'center',
      flex: 1,
      valueFormatter: (params) =>{ return feeFormatter(params)}
    },
    { field: 'expert_advice_days', 
      headerName: 'Expert Days', 
      align: 'center',
      headerAlign: 'center',
      flex: 1,
      valueFormatter: (params) =>{ if(params == -1){
          return `0 days`
        }else{
          return `${params} days`
        }
      }
    },
    {
      field: 'expert_advice_fee',
      headerName: 'Expert Fee',
      type: 'number',
      align: 'center',
      headerAlign: 'center',
      flex: 1,
      valueFormatter: (params) =>{ return feeFormatter(params)}
    },
    { field: 'wealth_vault_days', 
      headerName: 'Wealth Vault Days', 
      align: 'center',
      headerAlign: 'center',
      flex: 1,
      valueFormatter: (params) =>{ if(params == -1){
        return `0 days`
      }else{
        return `${params} days`
      }
    }
    },
    {
      field: 'wealth_vault_fee',
      headerName: 'Wealth Vault Fee',
      type: 'number',
      align: 'center',
      headerAlign: 'center',
      flex: 1,
      valueFormatter: (params) =>{ return feeFormatter(params)}
    },
    { field: 'status', 
      headerName: 'Franchise Status', 
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', alignContent:'center', height: '100%'}}>
                {params.value ? (<DoneIcon style={{ fontSize: '20px', color: '#4CAF50' }} />) : (<CloseIcon style={{ fontSize: '20px', color: 'red' }} />)}
        </div>
      ),
      flex: 1
    },
    { field: 'app_download_status', 
      headerName: 'App Download Status', 
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', alignContent:'center', height: '100%'}}>
                {params.value ? (<DoneIcon style={{ fontSize: '20px', color: '#4CAF50' }} />) : (<CloseIcon style={{ fontSize: '20px', color: 'red' }} />)}
        </div>
      ),
      flex: 1
    },
    { 
      headerName: 'View',
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', alignContent:'center', height: '100%' }}>
            <IconButton
                key={params.row.id}
                onClick={() => {
                  setHandleModal("View")
                  console.log("row",params.row)
                  setRecord(params.row)
                }}>
                <RemoveRedEyeIcon style={{ fontSize: '20px', color:'#00acfe'}} />
            </IconButton>           
        </div>
      ),
      flex: 1,
    },
    { 
      field: 'id',
      headerName: 'Edit',
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', alignContent:'center', height: '100%' }}>
            <IconButton
                key={params.row.id}
                onClick={() => {
                  setHandleModal("Edit")
                  setRecord(params.row)
                }}>
                <EditIcon style={{ fontSize: '20px', color:'#F8F8F0'}} />
            </IconButton>           
        </div>
      ),
      flex: 1,
    },
  ];
  
  const rows = franchiseList
  
  const paginationModel = { page: 0, pageSize: 10 };

  const textFieldProps = {
    InputLabelProps: {
        style: {
            color: '#FFFFFF',
            fontFamily: 'cardiuma-regular',
            fontSize: '14px',
            fontStyle: 'normal'
        }
    },

    InputProps: {
        style: {
            color: '#FFFFFF',
            width: '100%',
            height: '100%'
        }
    },

    style: {
        width: '240px',
        height: '45px',
        marginRight: '0.5%',
        backgroundColor: '#131E2E'
    }
}

  return (
    <Grid sx={{marginRight:'1% !important'}}>
      <Grid className={classes.subGrid}>
        <FormControlLabel sx={{color:'#ffffff !important'}} control={<Checkbox sx={{color:'#f44748','&.Mui-checked': { color:'#f44748'}}} checked={checkStatus} onChange={handleCheckStatus} />} label=" Franchise Status" />
        <FormControlLabel sx={{color:'#ffffff !important'}} control={<Checkbox sx={{color:'#f44748','&.Mui-checked': { color:'#f44748'}}} checked={checkApp} onChange={handleCheckApp} />} label="App Download Status" />
        <TextField value={search} onChange={(e) => {
              if(e.target.value === ""){
              handleReset()
            }  
            setSearch(e.target.value)}
          }
          label="Search" variant="outlined" sx={{height:'40px !important'}} {...textFieldProps}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSearch(search);
            }
        }} />
        <Button className={classes.button} sx={{margin:'0px 0px 10px 10px !important'}} onClick={()=>{
          setSearch("")
          handleReset()}}>Reset</Button>
        <Button className={classes.button} 
            sx={{margin:'0px 10px 10px 10px !important'}}
            onClick={()=>{
              setHandleModal("Add")
              setRecord({
                franchisee_code:"",
                franchiseetype:"",
                feeamount:"499",
                name:"",
                email:"",
                mobile:"",
                district:"",
                state:"",
                pincode:"",
                expert_advice_fee:"1999",
                expert_advice_days:"-1",
                wealth_vault_fee:"4999",
                wealth_vault_days:"-1",
                status: false,
                app_download_status:false
              })
          }}>Add</Button>
      </Grid>
      <Paper className={classes.horizantalTablayout} sx={{ height: '80vh', width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{ pagination: { paginationModel } }}
        pageSizeOptions={[10, 25 ,50]}
        className={classes.customDataGrid}
        sx={{
          '--DataGrid-containerBackground': '#131E2E',
          '--DataGrid-rowBorderColor': '#000',
          'border': 0,
          borderRadius:'15px !important',
      }}
      />
    </Paper>
    </Grid>
  );
};
export default withStyles(styles)(FranchiseTable);
